















































































































































































































import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Component, Inject } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  DOCUMENTS_LIST,
  DOWNLOAD_DOCUMENT,
  GET_MISSING_DOCUMENT_LIST,
  MISSING_DOCUMENTS,
  SET_MISSING_DOCUMENTS,
  SET_REMOVE_MISSING_DOCUMENT_FLAG,
  SET_UPLOAD_MISSING_DOCUMENT_FLAG,
  UPLOAD_CLICKED,
} from '@/types/documents.types';
import { Documents } from '@/models/form/Documents.model';
import { InputFile } from '@/models/InputFile.model';
import { FORM101_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { GET_MANAGER_DOCUMENT_CONTENT, MANAGER_MODE } from '@/types/managerForm.types';
import { Utils } from '@/globals/Utils';
import { UPLOAD_FILE_ENABLE } from '@/types/lobby.types';

@Component({
  components: {},
})
export default class DocumentsAndDeclarationStep extends FeedbackComponent {

  @Inject() public $validator: any;

  @Action(GET_MISSING_DOCUMENT_LIST, StoreNamespace.DOCUMENT) public getMissingDocumentList;
  @Action(DOWNLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public downloadDocument;
  @Action(UPLOAD_CLICKED, StoreNamespace.DOCUMENT) public uploadClicked;
  @Action(GET_MANAGER_DOCUMENT_CONTENT, StoreNamespace.MANAGER) public managerDownloadDocument;

  @Mutation(SET_MISSING_DOCUMENTS, StoreNamespace.DOCUMENT) public setMissingDocuments;
  @Mutation(SET_REMOVE_MISSING_DOCUMENT_FLAG, StoreNamespace.DOCUMENT) public setRemoveMissingDocumentsFlag;
  @Mutation(SET_UPLOAD_MISSING_DOCUMENT_FLAG, StoreNamespace.DOCUMENT) public setUploadMissingDocumentsFlag;
  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(DOCUMENTS_LIST, StoreNamespace.DOCUMENT) public documentsList!: Documents[];
  @Getter(MISSING_DOCUMENTS, StoreNamespace.DOCUMENT) public missingDocuments!: Documents[];
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public uploadFileEnable!: boolean;

  private missingFiles: [] = [];
  private agreement: boolean = false;
  public showEffectiveDate: boolean = false;
  public effectiveDate: Date | string | null = '' ;
  public taxYearBeginDateFrom: Date = new Date() ;
  public taxYearBeginDateTo: Date = new Date() ;

  public updateDate(date: Date, property: any) {
    this.updateForm101Data(date ? Utils.dateToString(date) : date, property);
  }
  public updateForm101Data(newVal: any, property: string) {
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }

  public mounted() {
    this.showEffectiveDate  = (this.form101Data.revision !== 1);
    this.taxYearBeginDateFrom = new Date(this.form101Data.taxYear,12,0 );
    this.taxYearBeginDateTo = new Date(this.form101Data.taxYear,1,0  );
  }

  public created() {
    this.agreement = this.formReadOnlyMode;
    this.$validator.localize({
      he: {
        custom: {
          // the field name
          הצהרה: {
            // the rules
            required: this.$t('invalidDeclarationErrorMessage'),
          },
          effectiveDate: {
            // the rules
            required: this.$t('form101.wizard.effectiveDateError'),
          },
        },
      },
    });
  }

  public onDownloadClicked(file: InputFile) {
    if (this.managerMode) {
      this.managerDownloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else {
      this.downloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
        },
      });
    }
  }

  public openDeleteDialog(file: InputFile) {
    if (file.docId) {
      this.setRemoveMissingDocumentsFlag(true);
      this.$root.$emit('openDeleteFileDialog', file);
    }
  }

  public onUploadClicked(inputFile: InputFile, docType: number) {
    this.uploadClicked({
      requestBody: {
        inputFile,
        docType,
        formId: this.form101Data.formId,
      },
    });
  }
}
